// extracted by mini-css-extract-plugin
export default {"darkmode_icon":"DarkmodeIcon_darkmode_icon__hdFS+","dark-theme":"DarkmodeIcon_dark-theme__rEWYD"};